import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

// components
import {
  Radio,
  DatePicker,
  TextInput,
  TextBlock,
} from '../components/inputs';
import { FormRow } from '../components/layout';

/* eslint-disable camelcase */
function ElectionPeriod() {
  const dispatch = useDispatch();
  const {
    values: { enrolltype, sep_code },
    options: { sep },
  } = useSelector(store => store);
  const options = sep.map(opt => ({ value: opt.code, desc: opt.desc, label: opt.code }));
  const needsDate = sep.map(opt => (opt.needsDate ? opt.code : undefined));
  const needsReason = sep.map(opt => (opt.needsReason ? opt.code : undefined));

  return (
    <div>
      <FormRow>
        <TextBlock name="enrolltype_text_block" />
        <Radio
          label="Election period"
          name="enrolltype"
          unsetFieldsOnCondition={{
            condition: (enrolltype === 'SEP'),
            fieldsToUnset: ['sep_code', 'sep_other', 'sep_date'],
          }}
        />
      </FormRow>
      <FormRow>
        {(enrolltype === 'SEP') && (
          <Radio
            label="Please specify the applicable SEP code"
            name="sep_code"
            options={options}
            onChangeCallback={() => {
              ['sep_other', 'sep_date'].forEach(name => {
                dispatch({ type: 'SET_FIELD_VALUE', name, value: undefined });
                dispatch({ type: 'SET_FIELD_VALIDATION', name, value: undefined });
              });
            }}
          >
            {needsDate.includes(sep_code) && (
              <div className="mb-3">
                <DatePicker
                  label="Date of event"
                  name="sep_date"
                />
              </div>
            )}
            {needsReason.includes(sep_code) && (
              <TextInput
                label="Please specify the reason"
                name="sep_other"
              />
            )}
          </Radio>
        )}
      </FormRow>
    </div>
  );
}

export default ElectionPeriod;
